(ns frontend.view.entity-viewers.modules.check-list.view
  (:require
   [common.localization :as loc]
   [common.schema.entities.pipeline :as pipeline]
   [common.schema.registry :as registry]
   [frontend.actions.entity :as entity-actions]
   [frontend.state.current-session :as session]
   [frontend.state.permissions :as f-permissions]
   [reagent.core :as r]
   [ui.components.toggle.view :as toggle]))

(defn render-module
  [check-list-entity-atom entity-atom]
  (let [entity @entity-atom
        tenant-fields-in-use (set (:tenant/fields-in-use @session/tenant))]
    [:div
     [:ul
      {:class "flex flex-col gap-3"}
      (->> @check-list-entity-atom
           :check-list/configuration
           (filter tenant-fields-in-use)
           (keep (fn [field]
                   (when (f-permissions/field-read-access? field
                                                           (:entity/type entity)
                                                           (pipeline/entity-pipeline entity))
                     (let [field-schema (registry/get-field-schema @session/tenant-schema field)]
                       ^{:key (str "check-list-" (:db/id entity) "-" field)}
                       [:li
                        {:class "px-2 py-3 flex gap-3 items-center"}
                        [:label
                         (loc/field-name field field-schema)]
                        [toggle/toggle
                         {:checked?   (boolean (get entity field))
                          :disabled?  (not (f-permissions/field-write-access? field
                                                                              (:entity/type entity)
                                                                              (pipeline/entity-pipeline entity)))
                          :on-change (fn [v]
                                        (let [old-value (get @entity-atom field)]
                                          ;; optimistic save
                                          (swap! entity-atom assoc field v)
                                          (entity-actions/*->field-update!
                                           (:db/id entity)
                                           field
                                           v
                                           identity
                                           (fn [err]
                                             ;; optimistic save revert
                                             (let [current-value (get @entity-atom field)]
                                               (when (and (= current-value v)
                                                          (not= current-value old-value))
                                                 (js/console.log "Revert old value")
                                                 (swap! entity-atom assoc field old-value)))))))}]
                       ]))))
           (doall))
     ]]))

(defn view
  [{:keys [parent-entity-id checklist-entity-id]}]
  (let [entity-atom (r/cursor session/entities [parent-entity-id])
        check-list-entity-atom (r/cursor session/entities [checklist-entity-id])]
    (fn [args]
      [render-module check-list-entity-atom entity-atom])))

(defn header-view
  [tenant-schema entity-id check-list-id]
  (let [check-list-entity (session/get-entity check-list-id)
        entity (session/get-entity entity-id)
        fields (:check-list/configuration check-list-entity)
        tenant-fields-in-use (set (:tenant/fields-in-use @session/tenant))
        fields-in-use (->> fields
                           (filter tenant-fields-in-use)
                           (filter (fn [field]
                                     (f-permissions/field-read-access? field
                                                                       (:entity/type entity)
                                                                       (pipeline/entity-pipeline entity)))))
        total-count (count fields-in-use)
        set-count (->> fields-in-use
                       (filter (fn [f]
                                 (true? (get entity f))))
                       (count))]
    [:div
     {:style {:display     :flex
              :align-items :center
              :cursor      :default}}
     [:div
      {:style {:font-weight   "400"
               :color         "#a1a1aa"
               :padding-right "8px"}}
      (str set-count "/" total-count)]
     (cond
       (zero? set-count)
       [:i.fal.fa-circle]
       (= set-count total-count)
       [:i.fas.fa-check-circle
        {:class "text-base-light-text-accent"}]
       :else
       [:i.fas.fa-chart-pie
        {:class "text-warning-light-text"}])]))
